import React from 'react';
import { Box, Flex, Skeleton } from '@radix-ui/themes';

const FieldSkeleton = () => {
   return (
      <Flex direction="column" gap="2">
         <Skeleton>
            <Box height="12px" width="120px"></Box>
         </Skeleton>
         <Skeleton>
            <Box height="40px" width="100%"></Box>
         </Skeleton>
      </Flex>
   );
};

export const CandidateProfileSekelton = () => {
   return (
      <Flex direction="column" gap="6" width="100%">
         <Box>
            <Skeleton>
               <Box height="22px" width="120px" mb="3"></Box>
            </Skeleton>

            <Flex gap="4" align={{ initial: 'start', sm: 'center' }} direction={{ initial: 'column', sm: 'row' }}>
               <Skeleton>
                  <Box
                     width="96px"
                     height="96px"
                     style={{
                        minWidth: '96px',
                        minHeight: '96px',
                        flexShrink: 0,
                        borderRadius: '50%',
                     }}
                  ></Box>
               </Skeleton>

               <Flex direction="column" gap="2" width="100%" maxWidth="460px">
                  <Flex gap="2" wrap="wrap">
                     <Skeleton>
                        <Box height="32px" width="118px"></Box>
                     </Skeleton>
                     <Skeleton>
                        <Box height="32px" width="118px"></Box>
                     </Skeleton>
                     <Skeleton>
                        <Box height="32px" width="102px"></Box>
                     </Skeleton>
                  </Flex>

                  <Skeleton>
                     <Box height="12px" width="100%" maxWidth="430px"></Box>
                  </Skeleton>
                  <Skeleton>
                     <Box height="12px" width="100%" maxWidth="320px"></Box>
                  </Skeleton>
               </Flex>
            </Flex>
         </Box>

         <Box>
            <Flex gap="5">
               <Skeleton>
                  <Box height="24px" width="170px"></Box>
               </Skeleton>
               <Skeleton>
                  <Box height="24px" width="170px"></Box>
               </Skeleton>
            </Flex>
            <Skeleton>
               <Box height="1px" width="100%" mt="2"></Box>
            </Skeleton>
         </Box>

         <Flex direction="column" gap="4" width="100%">
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
         </Flex>
      </Flex>
   );
};
